import { render } from "./BtnMultiDropdown.vue?vue&type=template&id=9d1ed580&scoped=true&ts=true&lang=pug"
import script from "./BtnMultiDropdown.vue?vue&type=script&lang=ts"
export * from "./BtnMultiDropdown.vue?vue&type=script&lang=ts"

import "./BtnMultiDropdown.vue?vue&type=style&index=0&id=9d1ed580&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d1ed580"]])

export default __exports__